'use client';

import Image from 'next/image';
import { useRef, Fragment } from 'react';
import { easeIn, easeInOut, easeOut, motion, useScroll, useTransform } from 'framer-motion';
import { PortableTextBlock } from 'sanity';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { useIsMobile } from '@/hooks/useIsMobile';

interface IBigTextProps {
  title: PortableTextBlock[];
  titleMobile: {
    titleMobileOne: PortableTextBlock[];
    titleMobileTwo: PortableTextBlock[];
  };
}

export default function BigText({
  title,
  titleMobile,
}: IBigTextProps) {
  const isMobile = useIsMobile();

  return (
    <section className="flex flex-col items-center justify-center w-full">
      {/* Desktop */}
      <div className="container lg:flex items-center justify-center w-full lg:min-h-[80rem] py-[18rem] lg:py-0 relative px-[7.5rem] lg:px-0">
        <motion.div
          initial={{ opacity: 0, scale: 0.4 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true, margin: "-100px" as const }}
          className="richtext richtext-center prose-headings:text-[3.75rem] lg:prose-headings:text-[7.5rem] max-w-[183.125rem] relative z-10"
        >
          <PortableText value={title} components={richTextComponent} />

          <svg className="absolute top-[-5rem] lg:top-[-2.5rem] left-[-4.5rem] lg:left-[-3rem] w-[5.875rem] h-[5.875rem] z-10" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.8147e-06 -2.05444e-06L1.76026e-06 47L14.5942 47L14.5942 12.5603L47 12.5603L47 0L3.8147e-06 -2.05444e-06Z" fill="#B0F4B7"/>
          </svg>
          <svg className="absolute bottom-[-5rem] lg:bottom-[-2.5rem] right-[-4.5rem] lg:right-[-3rem] w-[5.875rem] h-[5.875rem] z-10" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M47 47L47 -3.25423e-06L32.4058 -3.42826e-06L32.4058 34.4397L1.49781e-07 34.4397L3.86402e-07 47L47 47Z" fill="#B0F4B7"/>
          </svg>
        </motion.div>
      </div>
    </section>
  );
}
